import React from "react";
import PropTypes from "prop-types";
import classNames from "../../utils/classNames";

const Grid = ({ className, center, reverse, column, children, ...props }) => (
  <div
    className={classNames("coop-l-grid", [
      center && "coop-u-flex-center",
      reverse && "coop-u-flex-row-reverse",
      column && "coop-u-flex-column",
      className,
    ])}
    {...props}
  >
    {children}
  </div>
);

Grid.defaultProps = {
  className: "",
  center: false,
  reverse: false,
  column: false,
  children: null,
};

Grid.propTypes = {
  className: PropTypes.string,
  center: PropTypes.bool,
  reverse: PropTypes.bool,
  column: PropTypes.bool,
  children: PropTypes.node,
};

export default Grid;
